import { c as _c } from "react/compiler-runtime";
import { useToast } from "@flat-ui";
import { getAddMembersToTeamErrors } from "@utils/team-utils";
import { useCallback } from "react";
/** This hook returns functions that checks the backend response and show related toast message based on it */
export function useRespondToInvite() {
  const $ = _c(7);
  const {
    openToast
  } = useToast();
  let t0;
  if ($[0] !== openToast) {
    t0 = (response, numberOfMembers) => {
      const responseMessage = response.data.message;
      const additionalMessages = [];
      if (response.errorData) {
        response.errorData.details.failedInvitations?.forEach(error => {
          additionalMessages.push(error.message);
        });
        response.errorData.details.failedPermissions?.forEach(error_0 => {
          additionalMessages.push(error_0.message);
        });
      }
      if (additionalMessages.length === 0) {
        openToast({
          title: "Invitations sent",
          message: responseMessage
        });
      } else {
        if (additionalMessages.length < numberOfMembers) {
          openToast({
            title: responseMessage,
            message: additionalMessages.join("\n"),
            variant: "warning"
          });
        } else {
          if (additionalMessages.length === numberOfMembers) {
            openToast({
              title: responseMessage,
              message: additionalMessages.join("\n"),
              variant: "error"
            });
          } else {
            throw new Error("Number of additional messages cannot be larger than the actual requests");
          }
        }
      }
    };
    $[0] = openToast;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const respondToUser = t0;
  let t1;
  if ($[2] !== openToast) {
    t1 = (response_0, numberOfMembers_0) => {
      const additionalMessages_0 = getAddMembersToTeamErrors(response_0);
      let toastType = "success";
      if (additionalMessages_0.length > 0) {
        toastType = additionalMessages_0.length < numberOfMembers_0 ? "warning" : "error";
      }
      openToast({
        variant: toastType,
        title: "Invitations sent",
        message: additionalMessages_0.join("\n")
      });
    };
    $[2] = openToast;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const respondToTeamInvite = t1;
  let t2;
  if ($[4] !== respondToTeamInvite || $[5] !== respondToUser) {
    t2 = {
      respondToUser,
      respondToTeamInvite
    };
    $[4] = respondToTeamInvite;
    $[5] = respondToUser;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}